import angular from "angular";

angular
    .module('app')
    .component('employeeImportInfo', {
        template: require('./employee-import-info.html'),
        controller: ['$http', 'notifier', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, notifier, moment) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.employee = $ctrl.resolve.employee;

        $ctrl.fields = $ctrl.resolve.fields;

        $ctrl.fieldValues = {};

        $ctrl.fields.forEach(field => {
            const fieldValue = $ctrl.employee.field_values.find(v => v.field_id === field.id);

            $ctrl.fieldValues[field.id] = fieldValue ? fieldValue.value : null;
        });
    };

}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/employee-import-info/employee-import-info.js